module.exports = __webpack_public_path__ + "img/CustomerService.5f677722.svg";